'use strict';

export function showMissingLSD(options) {

    if (!options){
        options = {};
    }

    if (!options.classFilter) {
        options.classFilter = '';
    }

    if (!options.categoryFilter) {
        options.categoryFilter = '';
    }

    if (!options.farmFilter) {
        options.farmFilter = '';
    }

    if (!options.statusFilter) {
        options.statusFilter = '';
    }

    var yearendURL = '/pages/ajax_generic_search.cfm?' + jQuery.param({
        'type': 'ye_missing_lsd',
        'f_onSelect': 'false',
        'gridSelector': 'jq_ye_missing_lsd',
        'includeAdvancedSearch': 'false',
        'rowsPerPage': 200,
        'gridHeight': 130,
        'disableGridFix': 'true',
        'hidePagerPaging': 'true',
        'HorseClass_ID': options.classFilter,
        'HorseCategory_ID': options.categoryFilter,
        'HorseFarm_ID': options.farmFilter,
        'HorseStatus_ID': options.statusFilter,

    });

    redirect_refresh('',yearendURL,'#pop_yearend_review');
}

export function showExistingYearEnd(options) {

    $('#pop_warning_lsd:visible').customHide();
    $('#pop_important_lsd:visible').customHide();
    $('#pop_information_lsd:visible').customHide();
    $('#btnYEContinueLSD:visible').customHide();

    if (!options){
        options = {};
    }

    if (!options.classFilter) {
        options.classFilter = '';
    }

    if (!options.categoryFilter) {
        options.categoryFilter = '';
    }

    if (!options.farmFilter) {
        options.farmFilter = '';
    }

    if (!options.statusFilter) {
        options.statusFilter = '';
    }

    var yearendURL = '/pages/ajax_generic_search.cfm?' + jQuery.param({
        'type': 'ye_existing',
        'f_onSelect': 'false',
        'gridSelector': 'jq_ye_existing_lsd',
        'includeAdvancedSearch': 'false',
        'rowsPerPage': 200,
        'gridHeight': 130,
        'disableGridFix': 'true',
        'hidePagerPaging': 'false',
        'HorseClass_ID': options.classFilter,
        'HorseCategory_ID': options.categoryFilter,
        'HorseFarm_ID': options.farmFilter,
        'HorseStatus_ID': options.statusFilter,

    });

    redirect_refresh('',yearendURL,'#pop_yearend_review');
}

export function showNewYearEnd(options) {

    $('#pop_warning_existing:visible').customHide();
    $('#pop_important_existing:visible').customHide();
    $('#pop_information_existing:visible').customHide();
    $('#btnYEContinueExisting:visible').customHide();

    if (!options){
        options = {};
    }

    if (!options.classFilter) {
        options.classFilter = '';
    }

    if (!options.categoryFilter) {
        options.categoryFilter = '';
    }

    if (!options.farmFilter) {
        options.farmFilter = '';
    }

    if (!options.statusFilter) {
        options.statusFilter = '';
    }

    $('#btnYEFinsh:hidden').customShow();

    var yearendURL = '/pages/ajax_generic_search.cfm?' + jQuery.param({
        'type': 'ye_new_list',
        'f_onSelect': 'false',
        'gridSelector': 'jq_ye_new_list',
        'includeAdvancedSearch': 'false',
        'rowsPerPage': 200,
        'gridHeight': 130,
        'disableGridFix': 'true',
        'hidePagerPaging': 'true',
        'excludeids': '',
        'HorseClass_ID': options.classFilter,
        'HorseCategory_ID': options.categoryFilter,
        'HorseFarm_ID': options.farmFilter,
        'HorseStatus_ID': options.statusFilter,
    });

    redirect_refresh('',yearendURL,'#pop_yearend_review');

    $('#pop_important_new:hidden').customShow();
    $('#pop_information_new:hidden').customShow();



}

export function init(options) {
    if (!options) {
        options = {};
    }
    $('.jq_button').button();
}